import {ChemAPIJs} from "./chem.api.js.js";

export function ChemApiFactory(chem: ChemAPIJs) {
  return () => chem.initialise();
}
